import I18n from "i18next";
import { initReactI18next } from "react-i18next";

const isProduction = process.env.NODE_ENV === "production";

import { shopConfig } from "~/helpers/shopConfig";

import bg from "./bg.json";
import cs from "./cs.json";
import da from "./da.json";
import dk from "./da.json";
import de from "./de.json";
import el from "./el.json";
import en from "./en.json";
import es from "./es.json";
import fi from "./fi.json";
import fr from "./fr.json";
import hr from "./hr.json";
import it from "./it.json";
import ja from "./ja.json";
import jp from "./ja.json";
import nl from "./nl.json";
import no from "./no.json";
import pl from "./pl.json";
import pt from "./pt.json";
import ro from "./ro.json";
import sk from "./sk.json";
import sl from "./sl.json";
import se from "./sv.json";
import sv from "./sv.json";
import tr from "./tr.json";

I18n.use(initReactI18next).init(
  {
    debug: !isProduction,
    defaultNS: "common",
    fallbackLng: {
      bg: ["en"],
      cs: ["en"],
      da: ["en"],
      de: ["en"],
      default: ["en"],
      dk: ["en"],
      el: ["en"],
      en: ["en"],
      es: ["en"],
      fi: ["en"],
      fr: ["en"],
      hr: ["en"],
      it: ["en"],
      ja: ["en"],
      jp: ["en"],
      nl: ["en"],
      no: ["en"],
      pl: ["en"],
      pt: ["en"],
      ro: ["en"],
      se: ["en"],
      sk: ["en"],
      sl: ["en"],
      sv: ["en"],
      tr: ["en"]
    },
    lng: shopConfig.language,
    ns: ["common", "dashboard"],
    react: {
      bindI18n: "languageChanged loaded initialized",
      bindStore: "added removed",
      nsMode: "default",
      wait: false
    },
    resources: {
      bg,
      cs,
      da,
      de,
      dk,
      el,
      en,
      es,
      fi,
      fr,
      hr,
      it,
      ja,
      jp,
      nl,
      no,
      pl,
      pt,
      ro,
      se,
      sk,
      sl,
      sv,
      tr
    }
  },
  () => null
);

export const i18n = I18n;



// WEBPACK FOOTER //
// ./src/i18n/index.ts